/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcWarningTriangleFill({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M9.455 2.78c1.1-2.013 3.99-2.013 5.09 0l8.377 15.33c1.056 1.932-.342 4.29-2.544 4.29H3.622c-2.202 0-3.601-2.358-2.545-4.29zm1.369 5.968a1.178 1.178 0 1 1 2.351 0l-.292 4.92a.884.884 0 0 1-1.766 0zM10.5 17.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcWarningTriangleFill;
